import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSidenavStateStore = defineStore('sidenavState', () => {
  const isSidenavOpen = ref(false)

  function toggleSidenav() {
    isSidenavOpen.value = !isSidenavOpen.value
  }
  return {
    isSidenavOpen,
    toggleSidenav
  }
})
